import loadable from '@loadable/component';

const LazyWrappedMap = loadable(() => import('./WrappedMap'), {
  ssr: false,
});

export default LazyWrappedMap;
